







import ripple from "./ripple.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        ripple,
    }
})
export default class sideBar extends Vue {
    @Prop({}) maxResults: number;
    

}

